import type * as Prisma from "@iyk/database"

import * as UI from "@iyk/ui"

import { Link } from "@remix-run/react"

export const TeamHeadingLink = ({
  iconUrl,
  name,
  urlSlug,
}: Pick<Prisma.Team, "name" | "urlSlug" | "iconUrl">) => {
  const avatarUrl = iconUrl || UI.toInitialsSVG(name[0])

  return (
    <Link to={`/creators/${urlSlug}`} className="flex items-center gap-1.5">
      <UI.Avatar className="size-5" variant="square" src={avatarUrl} />
      <span className="text-xs-upper">{name}</span>
    </Link>
  )
}
